import { Button, Flex, Space } from 'antd'
import reportApi from 'api/reportApi'
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import GeneralReportTable from 'features/Report/components/Tables/GeneralReportTable'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import Empty from 'general/components/Empty'
import Loading from 'general/components/Loading'
import AppResource from 'general/constants/AppResource'
import ToastHelper from 'general/helpers/ToastHelper'
import useFilter from 'hooks/useFilter'
import { useAppSelector } from 'hooks/useRedux'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatReportParams, useLazyGeneralReport } from './queries'
// import './style.scss'

function GeneralReport() {
  const { t } = useTranslation()
  const sysConfig = useAppSelector((state) => state?.systemConfig.formatNumber)
  const [filters, setFilters] = useFilter(
    'generalReport',
    'gFiltersGeneralReport',
  )
  const [isExporting, setIsExporting] = useState(false)

  const {
    invoicesByTax,
    summaryTotals,
    isLoadingInitial,
    isFetchingNextPage,
    hasMore,
    fetchNextPage,
  } = useLazyGeneralReport(filters, sysConfig ?? {})

  // MARK --- Functions ---
  async function handleExportExcel(nameContract) {
    try {
      setIsExporting(true)
      const params = formatReportParams(filters)
      const response = await reportApi.exportInvoiceStatsByTax(params)
      const fileName = `${nameContract || 'Bang_ke_hoa_don_tong_hop'}.xlsx`
      saveAs(response, fileName)
      ToastHelper.showSuccess(t('Xuất file excel thành công!'))
    } catch (error) {
      console.error('Error exporting excel:', error)
      ToastHelper.showError(t('Xuất file excel thất bại, vui lòng thử lại!'))
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <ContentContainer wrapperClassName="GeneralReport">
      <ContentContainer.Header
        titleContent={t('Bảng kê hóa đơn tổng hợp')}
        toolBar={
          <CustomAntButton
            text={t('ExportExcel')}
            iconCn="fa-solid fa-down-to-line"
            antProps={{
              type: 'primary',
              className: 'btn btn-success',
              loading: isExporting,
              onClick: () =>
                handleExportExcel(
                  `Bang_ke_hoa_don_tong_hop_${dayjs(filters.startDate).format(
                    'L',
                  )}_${dayjs(filters.endDate).format('L')}`,
                ),
            }}
          />
        }
      >
        <Space size={4}>
          <FilterPopover
            menuPosition="bottomRight"
            onApply={setFilters}
            savedKey="gFiltersGeneralReport"
          />
          <KTTooltip
            text={`Sắp xếp ${
              filters?.order === 'ASC' ? 'tăng' : 'giảm'
            } theo ngày hóa đơn`}
          >
            <Button
              aria-label={`Sắp xếp ${
                filters?.order === 'ASC' ? 'tăng' : 'giảm'
              } theo ngày hóa đơn`}
              size="middle"
              style={{
                width: 36,
                height: 36,
                color: '#5180fb',
                backgroundColor: '#f3f6f9',
                border: 'none',
              }}
              icon={
                <i
                  className={`fa-solid ${
                    filters?.order === 'ASC' ? 'fa-arrow-up' : 'fa-arrow-down'
                  }`}
                  style={{ color: '#5180fb', fontSize: 20 }}
                />
              }
              onClick={() =>
                setFilters({
                  order: filters?.order === 'ASC' ? 'DESC' : 'ASC',
                })
              }
            />
          </KTTooltip>
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        {isLoadingInitial ? (
          <Flex justify="center" align="center" className="w-100 h-100">
            <Loading message="Đang tải dữ liệu" showBackground={false} />
          </Flex>
        ) : (
          <>
            {invoicesByTax?.length > 0 ? (
              <div className="overflow-auto">
                <GeneralReportTable
                  invoicesByTax={invoicesByTax}
                  summaryTotals={summaryTotals}
                  isLoadingInitial={isLoadingInitial}
                  isFetchingNextPage={isFetchingNextPage}
                  hasMore={hasMore}
                  fetchNextPage={fetchNextPage}
                />
              </div>
            ) : (
              <Empty
                text={t('NoData')}
                visible={false}
                imageEmpty={AppResource.icons.icEmptyBox}
                imageEmptyPercentWidth={30}
              />
            )}
          </>
        )}
      </ContentContainer.Body>
    </ContentContainer>
  )
}

export default GeneralReport
